import { Types } from '../../../actions/dashboards'
import { Metrics } from '../../../constants/Dashboards'
import buildAsyncStatReducer from './asyncStatReducer'

/**
 * L&L Dwell Timeline reducer
 */
const liftAndLearnDwellTimeline = buildAsyncStatReducer({
    key: Metrics.LIFTLEARN_DWELLTIMELINE,
    types: {
        request: Types.DASHBOARD_LIFTANDLEARN_DWELLTIMELINE.request,
        success: Types.DASHBOARD_LIFTANDLEARN_DWELLTIMELINE.success,
        failure: Types.DASHBOARD_LIFTANDLEARN_DWELLTIMELINE.failure,
    },
    transform: (state, { payload }) =>
        Object.keys(payload || {}).reduce((carry, date) => {
            return [
                ...carry,
                {
                    moment: date,
                    time: payload[date],
                },
            ]
        }, []),
})

/**
 * L&L Dwell Timeline per product reducer
 */
const liftAndLearnDwellTimelineProduct = buildAsyncStatReducer({
    key: Metrics.LIFTLEARN_DWELLTIMELINE_PRODUCTS,
    types: {
        request: Types.DASHBOARD_LIFTANDLEARN_DWELLTIMELINE_PRODUCT.request,
        success: Types.DASHBOARD_LIFTANDLEARN_DWELLTIMELINE_PRODUCT.success,
        failure: Types.DASHBOARD_LIFTANDLEARN_DWELLTIMELINE_PRODUCT.failure,
    },
    transform: (state, { payload }) => {
        return payload
    },
})

/**
 * L&L Dwell Time in average
 */
const liftAndLearnDwellTimeAverage = buildAsyncStatReducer({
    key: Metrics.LIFTLEARN_DWELLTIME_AVERAGE,
    types: {
        request: Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_AVERAGE.request,
        success: Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_AVERAGE.success,
        failure: Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_AVERAGE.failure,
    },
    transform: (state, { payload }) => {
        return payload?.average || 0
    },
})

/**
 * L&L Dwell Time in average
 */
const liftAndLearnDwellTimeBounceRate = buildAsyncStatReducer({
    key: Metrics.LIFTLEARN_DWELLTIME_BOUNCERATE,
    types: {
        request: Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_BOUNCERATE.request,
        success: Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_BOUNCERATE.success,
        failure: Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_BOUNCERATE.failure,
    },
    transform: (state, { payload }) => {
        return payload?.rate || 0
    },
})

/**
 * L&L Dwell Time in total
 */
const liftAndLearnDwellTimeTotal = buildAsyncStatReducer({
    key: Metrics.LIFTLEARN_DWELLTIME_TOTAL,
    types: {
        request: Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL.request,
        success: Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL.success,
        failure: Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL.failure,
    },
    transform: (state, { payload }) => {
        return payload?.total || 0
    },
})

/**
 * L&L Dwell Time in total
 */
const liftAndLearnDwellTimeTotalProduct = buildAsyncStatReducer({
    key: Metrics.LIFTLEARN_DWELLTIME_TOTAL_PRODUCTS,
    types: {
        request: Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL_PRODUCT.request,
        success: Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL_PRODUCT.success,
        failure: Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL_PRODUCT.failure,
    },
    transform: (state, { payload }) => {
        return payload
    },
})

/**
 * L&L Top Products
 */
const liftAndLearnTopProducts = buildAsyncStatReducer({
    key: Metrics.LIFTLEARN_TOP_PRODUCTS,
    types: {
        request: Types.DASHBOARD_LIFTANDLEARN_TOP_PRODUCTS.request,
        success: Types.DASHBOARD_LIFTANDLEARN_TOP_PRODUCTS.success,
        failure: Types.DASHBOARD_LIFTANDLEARN_TOP_PRODUCTS.failure,
    },
    transform: (state, { payload }) => {
        return payload.map(({ product, count }) => ({
            product,
            count,
        }))
    },
})

/**
 * L&L Top Stores
 */
const liftAndLearnTopStores = buildAsyncStatReducer({
    key: Metrics.LIFTLEARN_TOP_STORES,
    types: {
        request: Types.DASHBOARD_LIFTANDLEARN_TOP_STORES.request,
        success: Types.DASHBOARD_LIFTANDLEARN_TOP_STORES.success,
        failure: Types.DASHBOARD_LIFTANDLEARN_TOP_STORES.failure,
    },
    transform: (state, { payload }) => {
        return payload.map(({ store_code: storeCode, count }) => ({
            storeCode,
            count,
        }))
    },
})

/**
 * L&L total interaction
 */
const liftAndLearnTotalInteractions = buildAsyncStatReducer({
    key: Metrics.LIFTLEARN_TOTAL_INTERACTIONS,
    types: {
        request: Types.DASHBOARD_LIFTANDLEARN_TOTALINTERACTIONS.request,
        success: Types.DASHBOARD_LIFTANDLEARN_TOTALINTERACTIONS.success,
        failure: Types.DASHBOARD_LIFTANDLEARN_TOTALINTERACTIONS.failure,
    },
    transform: (state, { payload }) => {
        const { count = 0 } = payload[0] || {}
        return count
    },
})

const liftAndLearnReducers = [
    liftAndLearnDwellTimeline,
    liftAndLearnDwellTimelineProduct,
    liftAndLearnDwellTimeAverage,
    liftAndLearnDwellTimeBounceRate,
    liftAndLearnDwellTimeTotal,
    liftAndLearnDwellTimeTotalProduct,
    liftAndLearnTopProducts,
    liftAndLearnTopStores,
    liftAndLearnTotalInteractions,
]

export default liftAndLearnReducers
